import { PersistLanguageHelper } from "app/helpers/persistLanguageHelper";
import { ScreenType } from "app/utils/const";
import isPublicView from "app/utils/publicViewUtils";
import cloneDeep from "lodash/cloneDeep";
import * as profileApi from "../../api/profileApi";
import * as api from "../../api/sessionApi";
import * as apiUser from "../../api/userApi";
import { LanguageSelectionHelper } from "../../helpers/languageSelectionHelper";
import { SessionHelper } from "../../helpers/sessionHelper";
import store from "../store";
const SessionModal = {
  state: {
    session: {} as {},
    isIdle: false,
    loadingLogin: false,
    isPageVisible: true,
    downloadSpeed: Object,
    pingSent: false,
    pingReceived: false,
    darkMode: false,
    isLoggedIn: false,
  },
  reducers: {
    /** Start login loading */
    setLoginRequest(state: Record<string, any>, payload: any): any {
      return { ...state, loadingLogin: true };
    },

    /** End login loading */
    setLoginSuccess(state: Record<string, any>): any {
      return { ...state, loadingLogin: false, isLoggedIn: true };
    },
    /** toggle dark mode */
    toggleDarkMode(state: Record<string, any>): any {
      SessionHelper.saveDarkModeStatus(!state.darkMode);
      return { ...state, darkMode: !state.darkMode };
    },
    /** enable dark mode */
    enableDarkMode(state: Record<string, any>): any {
      return { ...state, darkMode: true };
    },

    // set Session session changes on login log out
    setUserSession(
      state: Record<string, any>,
      payload: any,
      { dispatch }: any
    ): any {
      const session = cloneDeep(state.session);
      // Merge old and new Session
      Object.assign(session, payload);

      // If user is NOT authenticated (i.e. session expired or logged out)
      if (!SessionHelper.isAuthenticated()) {
        // Dispatch actions to clear specific models
        dispatch.betSlipListModel.clear();
        dispatch.multiplesBetSlipListModel.clear();
        dispatch.betBuilderModel.clear();
      }

      // save session view to session storage
      localStorage.setItem("sessionView", payload.uiViewMode);
      return { ...state, session };
    },

    updateIsIdle(state: Record<string, any>, payload: any): any {
      const isIdle = payload;
      // update user session to idle
      return { ...state, isIdle };
    },

    setPageVisible(state: Record<string, any>, payload: boolean): any {
      // Updates when page changes visibility ie tab is selected/deselected or window minimised/maximised etc
      return { ...state, isPageVisible: payload };
    },

    // start loading
    setSessionRequest(state: Record<string, any>): any {
      return { ...state };
    },

    // Set the Session
    setSession(state: Record<string, any>, payload: any): any {
      const session = cloneDeep(state.session);
      // Merge old and new Session
      Object.assign(session, payload);
      // save session view to session storage
      localStorage.setItem("sessionView", payload.uiViewMode);
      return { ...state, session: session };
    },

    //
    setSessionView(state: Record<string, any>, payload: any): any {
      const session = cloneDeep(state.session);
      // merge new selected session view into session Object
      Object.assign(session, {
        uiViewMode: payload.preferences.uiViewMode,
      });
      // update session storage with new value
      localStorage.setItem("sessionView", payload.preferences.uiViewMode);
      return { ...state, session };
    },

    // set result of current network download speed
    setDownloadSpeed(state: Record<string, any>, payload: any): any {
      return { ...state, downloadSpeed: payload };
    },

    updateWebSocketPing(state: Record<string, any>): any {
      // ping response received from API update store
      return { ...state, pingReceived: true };
    },
    updatePingSent(state: Record<string, any>): any {
      // ping request sent to API update store
      return { ...state, pingSent: true, pingReceived: false };
    },
  },
  effects: {
    async loadSession(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ) {
      this.setSessionRequest();
      api.fetchSession().then(resp => {
        this.setSession(resp);
      });
    },

    /* update selected session view */
    async updateSessionView(payload: string, rootState: Record<string, any>) {
      // BET-5785 -  European tag ids shouldnt be used after changing to asian view
      if (payload === ScreenType.ASIAN) {
        sessionStorage.setItem("navNodeIds", "");
      }

      this.setSessionRequest();
      // api reqest
      apiUser
        .updatePreferences(payload, rootState.userModel.user)
        .then(resp => {
          this.setSessionView(resp);
          !isPublicView() &&
            SessionHelper.setOddsType(resp.preferences["oddsType"]);
        })
        .catch(error => {
          // if error returned by API log user out
          api.logout();
        });
    },

    /**
     * Log in the user
     * @param {*} payload
     * @param {*} rootState
     */
    async loginUser(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      // start loading
      this.setLoginRequest();
      return api
        .loginUser(payload.username, payload.password, payload.totpCode)
        .then(resp => {
          if (resp.twoFactorAuthenticationRequired) {
            return {
              requires2fa: true,
              success: false,
            };
          }
          this.setLoginSuccess();
          // Get token from response
          let sessionToken = resp.session["sessionToken"];
          resp.session.confirmedTerms =
            resp.account && resp.account["confirmedTerms"];
          resp.session.firstTimeUser =
            resp.account && resp.account["firstTimeUser"];
          // check if public view
          if (isPublicView()) {
            // New Session clear all local storage and cookies
            SessionHelper.clearSessionStorage();
            localStorage.clear();
            // check if new language selection needs to be persisted from 3et-ui
            PersistLanguageHelper.syncLanguageWithPublicView();
          }

          // Save token
          SessionHelper.saveToken(sessionToken);
          // save session view to session storage
          localStorage.setItem("sessionView", resp.session.uiViewMode);
          // Set session object on sessionModel
          this.setUserSession(resp.session);
          store.dispatch.userModel.setUser(resp.account);
          let userLang = resp.account.preferences.language;
          const languageInCookie =
            LanguageSelectionHelper.checkSelectedLanguage();
          const languageInCookieChanged =
            LanguageSelectionHelper.getLanguageChangedFromCookie();
          // If currently displayed language is not the same as the language in user's preferences,
          if (languageInCookie !== userLang) {
            // If user changes language on landing or login page, need to set that language when user logs in
            if (languageInCookieChanged) {
              // Update user's language preference
              try {
                profileApi.updateLanguage(
                  resp.account.userId,
                  resp.account.accountId,
                  resp.account.preferences.oddsType,
                  languageInCookie
                );
                // if using public view, reload the page
                if (isPublicView()) {
                  window.location.reload();
                }
              } catch (error) {
                console.error("Error updating language:", error);
              }
            } else {
              // User hasn't changed the language on the landing page, so load the language from user's preferences
              LanguageSelectionHelper.saveLanguageToCookie(userLang);
              window.location.reload(); // Reload newly set language
            }
          }
          return {
            requires2fa: false,
            success: true,
          };
        });
    },
  },
};
export default SessionModal;
